import { useEffect, useState } from 'react';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import Notification from '../../components/Notification';
import Table from '../../components/Table';

import { Container } from './styles';
import DeleteModal from '../../components/AlertModal';
import ModalWithTwoInput from '../../components/ModalWithTwoInput';
import PageHeader from '../../components/PageHeader';

const itemLabels = {
  name: { label: 'Material' },
};

const Materials = () => {
  const { loading } = useAuth();
  const [materials, setMaterials] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState({});

  async function fetchMaterials() {
    if (!loading) {
      try {
        const { data } = await api.get('/materials');
        setMaterials(data);
      } catch (err) {
        const error = err.response
          ? err.response.data.error
          : 'Ocorreu um erro ao buscar materiais';

        Notification({ message: error, type: Notification.types.ERROR });
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    fetchMaterials();
  }, [loading]);

  function handleDeleteButtonClick(user) {
    setSelectedMaterial(user);
    setDeleteModalOpen(true);
  }

  function handleDeleteModalClose() {
    setDeleteModalOpen(false);
    setTimeout(() => setSelectedMaterial({}), DeleteModal.closeTimeout);
  }

  async function handleDeleteModalConfirm() {
    try {
      setDeleteModalOpen(false);
      setLoading(true);
      await api.delete(`/admin/material/${selectedMaterial.id}`);
      fetchMaterials();
      Notification({
        message: 'Material excluído com sucesso',
        type: Notification.types.SUCCESS,
      });
    } catch (err) {
      const error = err.response
        ? err.response.data.error
        : 'Ocorreu um erro ao excluir material';

      Notification({ message: error, type: Notification.types.ERROR });
    } finally {
      setLoading(false);
    }
  }

  function handleAddButtonClick() {
    setAddModalOpen(true);
  }

  function handleCloseAddModal() {
    setAddModalOpen(false);
  }

  async function handleAddMaterial(data) {
    try {
      setAddModalOpen(false);
      setLoading(true);
      await api.post(`/admin/materials`, data);
      fetchMaterials();
      Notification({
        message: 'Material adicionado com sucesso',
        type: Notification.types.SUCCESS,
      });
    } catch (err) {
      const error = err.response
        ? err.response.data.error
        : 'Ocorreu um erro ao adicionar material';

      Notification({ message: error, type: Notification.types.ERROR });
    } finally {
      setLoading(false);
      setSelectedMaterial({});
    }
  }

  function handleEditButtonClick(material) {
    setSelectedMaterial(material);
    setEditModalOpen(true);
  }

  function handleCloseEditModal() {
    setEditModalOpen(false);
  }

  async function handleEditMaterial(data) {
    try {
      setEditModalOpen(false);
      setLoading(true);
      await api.put(`/admin/material/${selectedMaterial.id}`, data);
      fetchMaterials();
      Notification({
        message: 'Material editado com sucesso',
        type: Notification.types.SUCCESS,
      });
    } catch (err) {
      const error = err.response
        ? err.response.data.error
        : 'Ocorreu um erro ao editar material';

      Notification({ message: error, type: Notification.types.ERROR });
    } finally {
      setLoading(false);
      setSelectedMaterial({});
    }
  }

  return (
    <>
      <DeleteModal
        isOpen={deleteModalOpen}
        onClose={handleDeleteModalClose}
        onConfirm={handleDeleteModalConfirm}
        title={`Excluir ${selectedMaterial.name}`}
        text={`Deseja realmente excluir o material ${selectedMaterial.name}?`}
        type="delete"
      />
      <ModalWithTwoInput
        title="Adicionar material"
        text="Digite o nome do material que você deseja adicionar"
        isOpen={addModalOpen}
        onConfirm={handleAddMaterial}
        onClose={handleCloseAddModal}
        defaultValue={selectedMaterial}
      />
      <ModalWithTwoInput
        title="Editar material"
        text="Digite o novo nome do material"
        isOpen={editModalOpen}
        onConfirm={handleEditMaterial}
        onClose={handleCloseEditModal}
        defaultValue={selectedMaterial}
      />
      <Container>
        <PageHeader
          title="Materiais"
          buttonText="Adicionar novo material"
          onAddButtonClick={handleAddButtonClick}
        />
        {isLoading ? (
          <div className="loader" />
        ) : (
          <Table
            items={materials}
            headers={itemLabels}
            onDelete={handleDeleteButtonClick}
            onEdit={handleEditButtonClick}
          />
        )}
      </Container>
    </>
  );
};

export default Materials;
